module.exports = __webpack_public_path__ + "files/f29a76eef0ac92ba7f19ecf7954a0fba.png";